import React from "react"
import { NavLink } from "react-router-dom"
import { GiPadlock } from "react-icons/gi"

const Logo = () => {
  return (
    <>
      <div className="bg-white rounded-full p-2">
        <NavLink to="/">
          <div className="logo">
            <GiPadlock className="text-gray-900 text-6xl" />
          </div>
        </NavLink>
      </div>
    </>
  )
}

export default Logo
